<script>
import { defineComponent } from "vue";
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch.vue";
import { GravyPath, PackagingPath, RestaurantsPath } from "@/path";
import axios from "axios";
import Swal from "sweetalert2";

export default defineComponent({
  props: ["selectedOrder"],
  computed: {
    GravyPath() {
      return GravyPath;
    },
    RestaurantsPath() {
      return RestaurantsPath;
    },
  },
  components: { SelectWithSearch },
  data() {
    return {
      form: {
        gravies: [],
        packagings: [],
      },
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
      currentGPage: 1,
      currentPPage: 1,
      graviestotalRows: 1,
      packagingstotalRows: 1,
      graviesSearch: "",
      packagingsSearch: "",
      gravies: [],
      packagings: [],
      cdn: process.env.VUE_APP_AWS_CDN,
      search: "",
      // qty_delivered = what the outlet actually received: the GRN count on own
      // outlets, a copy of qty_shipped elsewhere. Shown here so ops can read the
      // received quantity without opening the deliver modal.
      fields: ["batch_code", "name", "qty_to_ship", "qty_shipped", "qty_delivered"],
      graviesFilter: "",
      packagingsFilter: "",
      key: 0,
    };
  },
  watch: {
    search() {
      this.currentPage = 1;
      this.getGravies();
    },
    packaging_search() {
      this.currentPPage = 1;
      this.getPackagings();
    },
  },
  mounted() {
    // Store-to-store transfer: no batch or locked qty — only what the sending store
    // sent and what the receiving store recorded on its GRN.
    if (this.selectedOrder?.source_res_id) {
      this.fields = [
        "name",
        { key: "qty_shipped", label: "Sent" },
        { key: "qty_delivered", label: "Received" },
      ];
    }
    if (Object.keys(this.selectedOrder).length > 0) {
      this.form.id = this.selectedOrder.id;
      this.form.special_instruction = this.selectedOrder.special_instruction;
      this.getOrderDetails();
    }
  },
  methods: {
    async getOrderDetails() {
      try {
        let res = await axios.get(this.baseUrl + GravyPath.ORDERS.ORDER_ITEMS, {
          params: {
            order_id: this.selectedOrder.id,
          },
        });
        if (res.data.status) {
          console.log(res.data.data);
          console.log(
            res.data.data
              .filter((f) => f.gravies != null)
              .map((f) => {
                let g = f.gravy;
                g.qty_to_ship = f.qty_to_ship;
                g.batch_code = f.batch_code;
                return g;
              })
          );
          this.form.gravies = res.data.data
            .filter((f) => f.gravy != null)
            .map((f) => {
              let g = f.gravy;
              g.qty_to_ship = f.qty_to_ship;
              g.qty_shipped = f.qty_shipped;
              g.qty_delivered = f.qty_delivered;
              g.batch_code = f.batch_code;
              if (f.no_qty_exists == 1) {
                g._rowVariant = "danger";
              }
              return g;
            });
          this.graviestotalRows = this.form.gravies.length;
          this.form.packagings = res.data.data
            .filter((f) => f.packaging != null)
            .map((f) => {
              let g = f.packaging;
              g.qty_to_ship = f.qty_to_ship;
              g.qty_shipped = f.qty_shipped;
              g.qty_delivered = f.qty_delivered;
              g.batch_code = f.batch_code;
              if (f.no_qty_exists == 1) {
                g._rowVariant = "danger";
              }
              return g;
            });
          this.packagingstotalRows = this.form.packagings.length;
        }
      } catch (e) {
        console.log(e);
      }
    },
    addGravy(v) {
      v.qty_to_ship = 1;
      this.form.gravies.push(v);
    },
    addPackaging(v) {
      v.qty_to_ship = 1;
      this.form.packagings.push(v);
    },
    setQty(e, v) {
      let index = this.form.gravies.findIndex(
        (f) =>
          f.id == v.id &&
          (v.batch_code == null ||
            this.baseUrl.batch_code == "" ||
            v.batch_code == f.batch_code)
      );
      if (isNaN(this.form.gravies[index].qty_to_ship)) {
        this.form.gravies[index].qty_to_ship = 0;
      }
      this.form.gravies[index].qty_to_ship = e;
      this.key += 1;
    },
    addQty(v) {
      let index = this.form.gravies.findIndex(
        (f) =>
          f.id == v.id &&
          (v.batch_code == null ||
            this.baseUrl.batch_code == "" ||
            v.batch_code == f.batch_code)
      );
      if (isNaN(this.form.gravies[index].qty_to_ship)) {
        this.form.gravies[index].qty_to_ship = 0;
      }
      this.form.gravies[index].qty_to_ship =
        parseInt(this.form.gravies[index].qty_to_ship) + 1;
      this.key += 1;
    },
    minusQty(v) {
      let index = this.form.gravies.findIndex(
        (f) =>
          f.id == v.id &&
          (v.batch_code == null ||
            this.baseUrl.batch_code == "" ||
            v.batch_code == f.batch_code)
      );
      if (isNaN(this.form.gravies[index].qty_to_ship)) {
        this.form.gravies[index].qty_to_ship = 0;
      }
      if (parseInt(this.form.gravies[index].qty_to_ship) - 1 < 1) {
        this.form.gravies.splice(index, 1);
        return;
      }
      this.form.gravies[index].qty_to_ship =
        parseInt(this.form.gravies[index].qty_to_ship) - 1;
      this.key += 1;
    },
    setPQty(e, v) {
      let index = this.form.packagings.findIndex(
        (f) =>
          f.id == v.id &&
          (v.batch_code == null ||
            this.baseUrl.batch_code == "" ||
            v.batch_code == f.batch_code)
      );
      if (isNaN(this.form.packagings[index].qty_to_ship)) {
        this.form.packagings[index].qty_to_ship = 0;
      }
      this.form.packagings[index].qty_to_ship = e;
      this.key += 1;
    },
    addPQty(v) {
      let index = this.form.packagings.findIndex(
        (f) =>
          f.id == v.id &&
          (v.batch_code == null ||
            this.baseUrl.batch_code == "" ||
            v.batch_code == f.batch_code)
      );
      if (isNaN(this.form.packagings[index].qty_to_ship)) {
        this.form.packagings[index].qty_to_ship = 0;
      }
      this.form.packagings[index].qty_to_ship =
        parseInt(this.form.packagings[index].qty_to_ship) + 1;
      this.key += 1;
    },
    minusPQty(v) {
      let index = this.form.packagings.findIndex(
        (f) =>
          f.id == v.id &&
          (v.batch_code == null ||
            this.baseUrl.batch_code == "" ||
            v.batch_code == f.batch_code)
      );
      if (isNaN(this.form.packagings[index].qty_to_ship)) {
        this.form.packagings[index].qty_to_ship = 0;
      }
      if (parseInt(this.form.packagings[index].qty_to_ship) - 1 < 1) {
        this.form.packagings.splice(index, 1);
        return;
      }
      this.form.packagings[index].qty_to_ship =
        parseInt(this.form.packagings[index].qty_to_ship) - 1;
      this.key += 1;
    },
    onGraviesFiltered(filteredItems) {
      this.graviestotalRows = filteredItems.length;
      this.currentGPage = 1;
    },
    onPackagingsFiltered(filteredItems) {
      this.packagingstotalRows = filteredItems.length;
      this.currentPPage = 1;
    },
    async acceptOrder() {
      try {
        let res = await axios.post(
          this.baseUrl + GravyPath.ORDERS.ACCEPT_ORDER,
          this.form
        );
        if (res.data.status) {
          Swal.fire("success", "", "success");
          this.$bvModal.hide("bv-accept-order");
          this.$emit("update");
        }
      } catch (e) {
        console.log(e);
      }
    },
    async updateOrder() {
      try {
        let res = await axios.put(
          this.baseUrl + GravyPath.ORDERS.SAVE + "/" + this.form.id,
          this.form
        );
        if (res.data.status) {
          Swal.fire("success", "", "success");
          this.$bvModal.hide("bv-add-order");
          this.$emit("update");
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getGravies() {
      try {
        let res = await axios.get(this.baseUrl + GravyPath.ALL, {
          params: {
            page: this.currentPage,
            search: this.search,
          },
        });
        if (res.data.status) {
          this.gravies = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getPackagings() {
      try {
        let res = await axios.get(this.baseUrl + PackagingPath.ALL, {
          params: {
            page: this.currentPPage,
            search: this.packaging_search,
          },
        });
        if (res.data.status) {
          this.packagings = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
});
</script>

<template>
  <div>
    <b-row>
      <b-col sm="6">
        <label>Restaurant</label>
        <p>{{ this.selectedOrder.restaurant.name }}</p>
      </b-col>
      <b-col sm="6">
        <label>Special Instruction</label>
        <p>{{ form.special_instruction }}</p>
      </b-col>
    </b-row>
    <b-card no-body>
      <b-tabs card>
        <b-tab title="Gravies">
          <div class="table-responsive mb-0">
            <div class="pb-2 float-md-right w-sm-100 w-md-25">
              <b-row class="mb-3">
                <b-col sm="12" class="mt-4">
                  <b-form-group
                    label-for="filter-input"
                    label-cols-sm="0"
                    label-align-sm="right"
                    label-size="sm"
                    class="mb-0"
                  >
                    <b-input-group size="sm">
                      <b-input-group-prepend is-text>
                        <i class="fa fa-search"></i>
                      </b-input-group-prepend>
                      <b-form-input
                        id="filter-input"
                        v-model="graviesFilter"
                        type="search"
                        placeholder="Type to Search"
                      ></b-form-input>

                      <b-input-group-append>
                        <b-button
                          :disabled="!graviesFilter"
                          @click="graviesFilter = ''"
                          >Clear</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <b-table
              :key="form.gravies.key"
              :items="form.gravies"
              :fields="fields"
              :per-page="10"
              responsive="sm"
              :filter="graviesFilter"
              :current-page="currentGPage"
              @filtered="onGraviesFiltered"
            >
              <template v-slot:cell(images)="row">
                <b-img
                  v-for="(im, i) in row.item.images"
                  :src="cdn + '/' + im.img_url"
                  :key="i"
                  size="20"
                ></b-img>
              </template>
              <template v-slot:cell(qty_to_ship)="row">
                <p>{{ row.item.qty_to_ship }}</p>
              </template>
              <template v-slot:cell(qty_shipped)="row">
                <p>{{ row.item.qty_shipped }}</p>
              </template>
            </b-table>
          </div>
          <div class="row">
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    :key="form.gravies.key"
                    v-model="currentGPage"
                    :total-rows="graviestotalRows"
                    :per-page="10"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Packaging">
          <div class="card-body">
            <div class="table-responsive mb-0">
              <div class="pb-2 float-md-right w-sm-100 w-md-25">
                <b-row class="mb-3">
                  <b-col sm="12" class="mt-4">
                    <b-form-group
                      label-for="filter-input"
                      label-cols-sm="0"
                      label-align-sm="right"
                      label-size="sm"
                      class="mb-0"
                    >
                      <b-input-group size="sm">
                        <b-input-group-prepend is-text>
                          <i class="fa fa-search"></i>
                        </b-input-group-prepend>
                        <b-form-input
                          id="filter-input"
                          v-model="packagingsFilter"
                          type="search"
                          placeholder="Type to Search"
                        ></b-form-input>

                        <b-input-group-append>
                          <b-button
                            :disabled="!packagingsFilter"
                            @click="packagingsFilter = ''"
                            >Clear</b-button
                          >
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <b-table
                :key="form.packagings.key"
                :items="form.packagings"
                :fields="fields"
                responsive="sm"
                :per-page="10"
                :filter="packagingsFilter"
                :current-page="currentPPage"
                @filtered="onPackagingsFiltered"
              >
                <template v-slot:cell(images)="row">
                  <b-img
                    v-for="(im, i) in row.item.images"
                    :src="cdn + '/' + im.img_url"
                    :key="i"
                    size="20"
                  ></b-img>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPPage"
                      :total-rows="packagingstotalRows"
                      :per-page="10"
                      :key="form.packagings.key"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<style></style>
